import { COMPANY } from "@/data/site";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <main data-testid="impressum-page" className="bg-ink-900 min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-32">
        <Link data-testid="impressum-back" to="/" className="inline-flex items-center gap-2 text-sm text-gold mb-10 hover:gap-3 transition-all">
          <ArrowLeft size={16} /> Zurück
        </Link>

        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Rechtliches</p>
        <h1 className="font-display text-5xl md:text-6xl text-white tracking-tight mb-12">
          Impressum.
        </h1>

        <div className="space-y-10 text-zinc-300 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Angaben gemäß § 5 TMG</h2>
            <p>{COMPANY.name}</p>
            <p>{COMPANY.address.street}</p>
            <p>{COMPANY.address.zip} {COMPANY.address.city}</p>
            <p>Deutschland</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Vertreten durch</h2>
            <p>Geschäftsführer: {COMPANY.ceo}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Kontakt</h2>
            <p>Telefon: <a className="hover:text-gold" href={COMPANY.phoneHref}>{COMPANY.phone}</a></p>
            <p>E-Mail: <a className="hover:text-gold" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Umsatzsteuer-ID</h2>
            <p>Eine Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz wird auf Anfrage mitgeteilt.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p>{COMPANY.ceo}</p>
            <p>{COMPANY.address.street}, {COMPANY.address.zip} {COMPANY.address.city}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a className="text-gold hover:underline ml-1" href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer noopener">
                https://ec.europa.eu/consumers/odr
              </a>.
            </p>
            <p className="mt-3">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Haftung für Links</h2>
            <p>
              Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir
              keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
